import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import BitwerxOfferingForm from './BitwerxOfferingForm';

const NewBitwerxOfferingModal = ({ isOpen, toggle, refresh }) => {
    return (
        <Modal
            className="text-light"
            isOpen={isOpen}
            centered
            style={{ minWidth: '50vw' }}>
            <ModalHeader>New Bitwerx Offering</ModalHeader>
            <ModalBody>
                <BitwerxOfferingForm isNew={true} closeForm={toggle} refresh={refresh} />
            </ModalBody>
        </Modal>
    );
};

export default NewBitwerxOfferingModal;
